import { defineAsyncComponent } from 'vue';

const DeleteAccessHistoryPopup = defineAsyncComponent(() =>
  import('@/views/accessHistory/popup/DeleteAccessHistoryPopup.vue')
);

export function registerAccessHistory(app) {
  app.component('DeleteAccessHistoryPopup', DeleteAccessHistoryPopup);
}
